(function(){
  if (window.__lpInit) return;
  window.__lpInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('lp-visible'); io.unobserve(e.target); } });
  }, {threshold: .15}) : null;

  function initReveals(root){
    root.querySelectorAll('.lp-reveal:not(.lp-visible)').forEach(function(el){
      if (!io || reduce) { el.classList.add('lp-visible'); return; }
      io.observe(el);
    });
  }
  function initHero(root){
    root.querySelectorAll('.lp-hero').forEach(function(h){
      if (h.dataset.lpInit) return; h.dataset.lpInit = '1';
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      h.addEventListener('mousemove', function(ev){
        var r = h.getBoundingClientRect();
        h.style.setProperty('--lp-gx', ((ev.clientX - r.left) / r.width * 100) + '%');
        h.style.setProperty('--lp-gy', ((ev.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }
  function initBeneficios(root){
    root.querySelectorAll('[data-lp-ben]').forEach(function(w){
      if (w.dataset.lpInit) return; w.dataset.lpInit = '1';
      var items = w.querySelectorAll('.lp-ben__item'), imgs = w.querySelectorAll('.lp-ben__media img');
      function abrir(i){
        items.forEach(function(it, j){ it.classList.toggle('is-open', i === j); it.querySelector('.lp-ben__btn').setAttribute('aria-expanded', i === j); });
        imgs.forEach(function(im, j){ im.classList.toggle('is-on', i === j); });
      }
      items.forEach(function(it, i){ it.querySelector('.lp-ben__btn').addEventListener('click', function(){ abrir(i); }); });
      abrir(0);
    });
  }
  function initBrillo(root){
    root.querySelectorAll('[data-lp-br]').forEach(function(w){
      if (w.dataset.lpInit) return; w.dataset.lpInit = '1';
      var range = w.querySelector('input'), cap = w.querySelector('.lp-br__caption'), estados = w.querySelectorAll('template');
      var bri = [0.55, 0.8, 1.08], halo = [.18, .34, .55];
      function pon(v){
        var i = Math.max(0, Math.min(estados.length - 1, v - 1));
        w.style.setProperty('--lp-bri', bri[i] || 1);
        w.style.setProperty('--lp-halo', halo[i] || .35);
        if (estados[i]) cap.innerHTML = estados[i].innerHTML;
      }
      range.addEventListener('input', function(){ pon(parseInt(range.value, 10)); });
      pon(parseInt(range.value, 10));
    });
  }
  function initTodo(root){ root = root && root.querySelectorAll ? root : document; initReveals(root); initHero(root); initBeneficios(root); initBrillo(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initTodo(document); });
  else initTodo(document);
  document.addEventListener('shopify:section:load', function(e){ initTodo(e.target); });
})();
